import { batch, signal } from "@preact/signals-react"


// Catalogues — loaded once when the page opens.
export const retailers = signal([])
export const totals = signal({ retailers: 0, sections: 0, newsletters: 0 })
export const taggers = signal([])

// Sections of the currently-open retailer in the drawer. Empty when
// the drawer is closed, or while loading after a retailer is opened.
export const drawerRetailerId = signal(null)
export const sections = signal([])

// Table filters (client-side). The toolbar bumps these and the table
// re-renders against the in-memory catalogue.
export const retailerSearch = signal('')
// Country filter (ISO-2, '' = all). Options derived from the loaded
// retailers' `country` values.
export const retailerCountry = signal('')
// Assigned mapper (= the retailer's QA owner, `id_user_assigned`):
// '' = all, 'none' = unassigned, '<id_user>' = that mapper.
export const retailerAssignee = signal('')
// Retailers ticked for a bulk action. An array (not a Set) so a new
// reference on every change makes the signal re-render predictably.
export const selectedRetailerIds = signal([])
export const retailerFilters = signal({
	// Admin opens pre-filtered by Active — the daily working set. Still a
	// pre-filter, not a forced one: the chip stays clickable.
	activeOnly:     true,
	hasPuig:        false,
	hasRetail:      false,
	missingPuig:    false,
	missingRetail:  false,
	withQa:         false,
	withoutQa:      false,
	hasNewsletter:  false,
	noSections:     false,
})

export const sectionSearch = signal('')
export const sectionFilters = signal({
	kindWeb:        false,
	kindNewsletter: false,
	hasPuig:        false,
	hasRetail:      false,
	activeOnly:     false,
	inactiveOnly:   false,
})


export const clearAdminSignals = () => batch(() => {
	retailers.value = []
	totals.value = { retailers: 0, sections: 0, newsletters: 0 }
	taggers.value = []
	drawerRetailerId.value = null
	sections.value = []
	retailerSearch.value = ''
	retailerCountry.value = ''
	retailerAssignee.value = ''
	selectedRetailerIds.value = []
	// `activeOnly: true` here too — resetting it to false would leave the
	// pre-filter off the second time the page is opened.
	retailerFilters.value = {
		activeOnly: true, hasPuig: false, hasRetail: false,
		missingPuig: false, missingRetail: false,
		withQa: false, withoutQa: false,
		hasNewsletter: false, noSections: false,
	}
	sectionSearch.value = ''
	sectionFilters.value = {
		kindWeb: false, kindNewsletter: false, hasPuig: false, hasRetail: false,
		activeOnly: false, inactiveOnly: false,
	}
})
